import { useAppPersistenceStore, useProfileStore } from '@ninjacart/nc-nk-store';
import { Spinner, useToastController, YStack } from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import React, { useEffect, useRef, useState } from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { WebView, WebViewMessageEvent } from 'react-native-webview';
import { useParams } from 'solito/navigation';
import { injectedJavaScript } from './helperJS';

const useParam = useParams<{
  id?: string;
  entityId?: string;
  entityType?: string;
  productType?: string;
}>;

const WVFormScreen: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id, entityId, entityType, productType } = useParam();
  const baseUrl = process.env.WEB_APP_URL;
  const webViewRef = useRef<WebView>(null);
  const router = useRouter();
  const toast = useToastController();
  const push = useRouter();
  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleIframeMessage = (event: MessageEvent) => {
        console.log('Message received:', event.data, 'from origin:', event.origin);

        // Try to parse the data
        let parsedData;
        try {
          parsedData = JSON.parse(event.data);
        } catch (err) {
          console.log('Message is not JSON, ignoring');
          return;
        }

        // Handle the message
        if (parsedData?.event === 'GO_BACK') {
          toast.show('Submitted Successfully!!!', { duration: 3000 });
          // Delay the navigation to allow the toast to show
          setTimeout(() => router.back(), 500);
        } else if (parsedData?.event === 'GO_BACK_CANCEL') {
          router.back();
        }
      };

      // Add event listener with proper options
      window.addEventListener('message', handleIframeMessage);

      return () => {
        window.removeEventListener('message', handleIframeMessage);
      };
    }
  }, [router, toast]);

  const handleMessage = (event: WebViewMessageEvent) => {
    if (event.nativeEvent?.data) {
      const eventData = JSON.parse(event.nativeEvent.data);
      if (eventData?.event === 'GO_BACK') {
        router.back();
        toast.show('Submitted Successfully!!!', {
          duration: 3000,
          message: 'Submitted Successfully!!!',
        });
      }

      if (eventData?.event === 'GO_BACK_CANCEL') {
        router.back();
      }
    }
  };

  const installRefferer = useAppPersistenceStore.getState().referInfo?.installReferrer;
  const name = useProfileStore.getState()?.userProfile?.user?.name;
  const phoneNumber = useProfileStore.getState()?.userProfile?.user?.primaryPhoneNumber;
  const pinCode = useProfileStore.getState()?.ipAddressLocation?.data?.pincode;
  const accessToken = useProfileStore.getState()?.userProfile?.access_token;
  const extraParams = {
    name: name || '',
    phoneNumber: phoneNumber || '',
    pinCode: pinCode || '',
    accessToken: accessToken || '',
  };
  const extraQuery = new URLSearchParams(extraParams).toString();
  const url = `${baseUrl}/leads/${id}?${extraQuery}&entityId=${entityId}&entityType=${entityType}&productType=${productType}&${installRefferer}&skipSplash=true`;

  console.log('🚀 ~ url:', url);



  if (Platform.OS === 'web') {
    return (
      <iframe
          src={url}
          style={{ flex: 1, width: '100%', height: '100vh', border: 'none' }}
        />
    );
  }
  return (
    <SafeAreaView style={{ flex: 1 }}>
      <YStack flex={1} backgroundColor="white">
        {isLoading && (
          <YStack
            position="absolute"
            justifyContent="center"
            alignItems="center"
            zIndex={10}
            width="100%"
            height="100%"
            backgroundColor="rgba(255, 255, 255, 0.8)"
          >
            <Spinner color="#368665" size="large" />
          </YStack>
        )}

        <WebView
          ref={webViewRef}
          source={{ uri: url }}
          onLoadStart={() => setIsLoading(true)}
          onLoadEnd={() => setIsLoading(false)}
          javaScriptEnabled={true}
          onMessage={handleMessage}
          injectedJavaScript={injectedJavaScript}
          style={{ flex: 1, width: '100%', height: 400 }}
        />
      </YStack>
    </SafeAreaView>
  );
};

export { WVFormScreen };
